var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{attrs:{"value":1,"unchecked-value":0},on:{"change":function($event){return _vm.updateValue()}},model:{value:(_vm.model.sodium_added),callback:function ($$v) {_vm.$set(_vm.model, "sodium_added", $$v)},expression:"model.sodium_added"}},[_vm._v(" Mi receta tiene sodio añadido. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }